import React, { useContext, useReducer, useState } from 'react'
import { SecurityContext } from '../../security/SecurityContext';
import { LoginFormDataReducer, loginFormDataInitialState } from './LoginFormDataReducer';
import { LoginFormValidationReducer, loginFormValidationInitialState } from './LoginFormValidationReducer';
import { FormField } from '../../uiwidgets/FormField';
import { FormContainer } from '../../uiwidgets/FormContainer';
import { SubmitButton } from '../../uiwidgets/SubmitButton';
import { Navigate, useSearchParams } from 'react-router-dom';
import { TenantContext } from '../../tenant/TenantContext';
import { PasswordField } from '../../uiwidgets/PasswordField';
import { Row, Col, Spinner, Alert } from 'react-bootstrap';
import PageContentContainer from 'uiwidgets/PageContentContainer';


function LoginPage() {
  const {
    authState,
    handleAuth,
    handleLogout,
    profile,
  } = useContext(SecurityContext);

  const VERIFICATION_REQUIRED = 'EMAIL_VERIFICATION_REQUIRED'
  const [regState, setRegState] = useState('');
  const { businessConfig } = useContext(TenantContext)
  const [formData, formDispatch] = useReducer(LoginFormDataReducer, loginFormDataInitialState);
  const [formValidityData, formValidityDispatch] = useReducer(LoginFormValidationReducer, loginFormValidationInitialState)
  const [searchParams, setSearchParams] = useSearchParams();

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    formDispatch({ type: 'FIELD_EDIT', payload: { name: name, value: value } })
  }

  const handleValidation = (event) => {
    let dispatchType = 'VALIDATE_' + event.target.name.toUpperCase();
    const name = event.target.name;
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    formValidityDispatch({ type: dispatchType, payload: { [name]: value } });

    if (name === 'usernameOrEmail') {
      let registrationState = businessConfig['registration-state'];
      setRegState(registrationState);
    }
  }


  const handleAuthenticationSuccess = (data) => {
    let userProfile = handleAuth(data)
    formDispatch({ type: 'FORM_SUBMIT_SUCCESS', payload: userProfile });

  }

  const handleAuthicationFailure = (data) => {
    handleLogout();
    formDispatch({ type: 'FORM_SUBMIT_FAIL', payload: data })
  }


  const handleSubmit = (event) => {
    event.preventDefault();
    if (!formValidityData.isFormValid) {
      alert("The form still has validation errors!");
      return false;
    }


    formDispatch({
      type: 'FORM_SUBMIT', payload: {
        formData: { ...formData },
        successFunction: handleAuthenticationSuccess,
        failureFunction: handleAuthicationFailure
      }
    });
  }

  if (!authState) {
    return (
      <>
      {formData.status && <PageContentContainer><Alert key="info" variant='info'>
        <Spinner animation="border" role="status" variant='dark' className="me-4" />
        {formData.status}
      </Alert></PageContentContainer>}
        <FormContainer title="Sign In" submitButtonFunction={handleSubmit} errors={formData.errors}>
          <Row><Col className="pe-1" md="8">
            <FormField name="usernameOrEmail" label="User Id" type="text" value={formData.usernameOrEmail}
              placeholder="Enter User Id" onChange={handleChange} onBlur={handleValidation}
              valstate={!formValidityData.usernameOrEmailError} valMsg={formValidityData.usernameOrEmailErrMsg} 
              readOnly={formData.readOnly}/>
          </Col></Row>
          <Row><Col className="pe-1" md="8">
            <PasswordField name="password" label="Password" value={formData.password}
              placeholder="Enter  Password" onChange={handleChange} onBlur={handleValidation}
              valstate={!formValidityData.passwordError} valMsg={formValidityData.passwordErrMsg} 
              readOnly={formData.readOnly}/>
          </Col></Row>
          <Row>
            <Col> &nbsp;</Col>
          </Row>
          <SubmitButton label='Login' />


        </FormContainer>
      </>
    );
  }

  else if (profile?.roles.includes('ROLE_BUSINESS_ADMIN') && regState === VERIFICATION_REQUIRED)
    return <Navigate to="/verifyemail" replace />
  else {
    if (searchParams.get('redirectTo')){
      return <Navigate to={searchParams.get('redirectTo')} replace />;
    } else {
      return <Navigate to="/home" replace />;
    }
  }
}

export default LoginPage;